/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ type: NonNullable<unknown> }} Coinvestments_Lpdealoverviewcontent_Namealreadyexists6Inputs */

const en_coinvestments_lpdealoverviewcontent_namealreadyexists6 = /** @type {(inputs: Coinvestments_Lpdealoverviewcontent_Namealreadyexists6Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`A ${i?.type} with this name already exists`)
};

/**
* | output |
* | --- |
* | "A {type} with this name already exists" |
*
* @param {Coinvestments_Lpdealoverviewcontent_Namealreadyexists6Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_lpdealoverviewcontent_namealreadyexists6 = /** @type {((inputs: Coinvestments_Lpdealoverviewcontent_Namealreadyexists6Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Lpdealoverviewcontent_Namealreadyexists6Inputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_lpdealoverviewcontent_namealreadyexists6(inputs)
});
export { coinvestments_lpdealoverviewcontent_namealreadyexists6 as "coInvestments_lpDealOverviewContent_nameAlreadyExists" }